module.exports = __webpack_public_path__ + "static/img/data.f47167b.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/zhsh/data.jpg
// module id = FdVp
// module chunks = 13